// src/hooks/useReviews.js
import { useEffect, useState } from "react";
import { getReviews } from "@/services/reviews.service";
import { localizeField } from "@/utils/i18nBackend";

function normalizeAvatar(avatar) {
  if (!avatar) return null;

  // Absolute URL
  if (avatar.startsWith("http")) return avatar;

  // Relative path from backend
  return `https://www.programshouse.com/hr/public/${avatar}`;
}

export function useReviews() {
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let active = true;

    async function fetchReviews() {
      try {
        setLoading(true);
        setError(null);

        const result = await getReviews();

        const formatted = Array.isArray(result?.data)
          ? result.data.map((item) => ({
              id: item.id,
              name: localizeField(item, "name"),
              role: localizeField(item, "position"),
              text: localizeField(item, "content"),
              avatar: normalizeAvatar(item.image),
            }))
          : [];

        if (active) setReviews(formatted);
      } catch (err) {
        if (active) {
          setError(
            err?.response?.data?.message ||
              err?.message ||
              "Failed to load reviews"
          );
        }
      } finally {
        if (active) setLoading(false);
      }
    }

    fetchReviews();

    return () => {
      active = false;
    };
  }, []);

  return { reviews, loading, error };
}